import { Component, HostBinding, OnInit } from '@angular/core';
declare var $: any;

import { SettingsService } from './core/settings/settings.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

    @HostBinding('class.layout-fixed') get isFixed() { return this.settings.layout.isFixed; };
    @HostBinding('class.aside-collapsed') get isCollapsed() { return this.settings.layout.isCollapsed; };
    @HostBinding('class.layout-boxed') get isBoxed() { return this.settings.layout.isBoxed; };
    @HostBinding('class.layout-fs') get useFullLayout() { return this.settings.layout.useFullLayout; };
    @HostBinding('class.hidden-footer') get hiddenFooter() { return this.settings.layout.hiddenFooter; };
    @HostBinding('class.layout-h') get horizontal() { return this.settings.layout.horizontal; };
    @HostBinding('class.aside-float') get isFloat() { return this.settings.layout.isFloat; };
    @HostBinding('class.offsidebar-open') get offsidebarOpen() { return this.settings.layout.offsidebarOpen; };
    @HostBinding('class.aside-toggled') get asideToggled() { return this.settings.layout.asideToggled; };
    @HostBinding('class.aside-collapsed-text') get isCollapsedText() { return this.settings.layout.isCollapsedText; };

    constructor(public settings: SettingsService) { }

    ngOnInit() {
    //     $(document).on('click', '[href="#"]', e => e.preventDefault());
    //       var OneSignal = window['OneSignal'] || [];
    //     console.log("Init OneSignal");
    //     OneSignal.push(["init", {
    //     //appId: "ace5d8a2-5018-4523-ab21-cff285d32524",
    //     appId:"9740a50f-587f-4853-821f-58252d998399",
    //     autoRegister: true, /* Set to true to automatically prompt visitors */
    //     subdomainName: 'https://restrntfire.onesignal.com',
    //     httpPermissionRequest: {
    //        enable: false
    //     },
    //     notifyButton: {
    //        enable: false// Set to false to hide 
    //     }
    // }]);
    // console.log('OneSignal Initialized');
    //  OneSignal.push(function () {
    //      console.log('Register For Push');
    //      OneSignal.push(["registerForPushNotifications"])
    //      OneSignal.getUserId().then(function (userId) {
    //       console.log("User ID is", userId);
    //       localStorage.setItem('playerId',userId)
    //     });
    // });

  }

}



// WEBPACK FOOTER //
// /Users/sooweeseng/Documents/Ionic Apps/ShunFa/ShunFa-Restaurant Backend/Restaurant_Firebasebackend/webapp/src/app/app.component.ts